export const UpsellWhatsAppClicks = (orderId) => {
  const event = {
    event: 'upsell_whatsapp_button_click',
    upsell_order: {
      order_id: orderId,
    },
  };

  window.dataLayer.push(event);
};

export const UpsellTabClicks = (orderId) => {
  const event = {
    event: 'upsell_tab_click',
    upsell_order: {
      order_id: orderId,
    },
  };

  window.dataLayer.push(event);
};

export default UpsellTabClicks;
